import { createSlice } from "@reduxjs/toolkit";
import editPackage from "@custom/rtk-apis/billing/editBilling";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const editPackageSlice = createSlice({
  name: "editPackageSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(editPackage.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editPackage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(editPackage.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default editPackageSlice.reducer;
export const { closeModal } = editPackageSlice.actions;
